let Offices = {
    init() {
        this.bind();
    },

    bind() {
        this.addForm();
        this.editForm();
        this.form();
        this.delete();
    },

    addForm() {
        let _this = this;

        const form = $('#officeForm');

        if (form.length) {
            $(document).on('click', '.add-group', () => {
                form.find('#officeId').val('');
                form.find('#officeName').val('');
                form.find('#officeLocation').val('');

                form.resetForm();
            });
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm() {
        let _this = this;

        const form = $('#officeForm');
        const modal = $('#officeModal');

        $(document).on('click', '.edit-office', function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/offices/' + id + '/json', response => {
                if (response.success) {
                    const office = response.data;

                    form.find('#officeName').val(office.name);
                    form.find('#officeLocation').val(office.location);
                    form.find('#officeId').val(office.id);

                    modal.modal('show');
                }
            });
        });
    },

    delete() {
        $(document).on('click', '.delete-office', function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/offices/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Office has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form() {
        let _this = this;
        const form = $('#officeForm');
    },
};

$().ready(function () {
    window.Offices = Offices;
    window.Offices.init();
});
